<template>
  <generic-error class="mt-48" :buttonValue="errorDetails.buttonValue" :buttonHref="errorDetails.buttonHref">
    {{ errorDetails.body }}
  </generic-error>
</template>

<script lang="ts">
import GenericError from '@/components/generic_error/GenericError.vue';

export default {
  name: 'ProviderProfileError',
  components: {
    GenericError,
  },
  props: {
    errorType: {
      type: String,
      default: '',
    },
  },
  computed: {
    errorDetails(): { body: string; buttonValue?: string; buttonHref?: string } {
      switch (this.errorType) {
        case 'PROFILE_UNAVAILABLE':
          return {
            body: 'This profile is currently unavailable. Please try again or check back later.',
          };
        default:
          return {
            body: 'There was an error with processing your request. Refresh the page to try again or contact us if the issue continues.',
            buttonValue: 'Contact Customer Success',
            buttonHref: 'https://support.sittercity.com/hc/en-us/requests/new',
          };
      }
    },
  },
};
</script>
